import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M11.713 6.99V4.88a3 3 0 0 0-3-3h-.75a3 3 0 0 0-3 3v2.11a2.75 2.75 0 0 0-2.63 2.75v2.86a2.75 2.75 0 0 0 2.7 2.75h6.61a2.75 2.75 0 0 0 2.75-2.75V9.74a2.75 2.75 0 0 0-2.68-2.75Zm-5.25-2.11a1.5 1.5 0 0 1 1.5-1.5h.75a1.5 1.5 0 0 1 1.5 1.5v2.11h-3.75V4.88Z';

const draw24px =
  'M17.413 10.78h-.82v-3a3.75 3.75 0 0 0-3.75-3.75h-1a3.75 3.75 0 0 0-3.75 3.7v3.05h-.82a2.75 2.75 0 0 0-2.75 2.75v5.14a2.75 2.75 0 0 0 2.75 2.75h10.14a2.75 2.75 0 0 0 2.75-2.75v-5.14a2.75 2.75 0 0 0-2.75-2.75Zm-7.82-3a2.25 2.25 0 0 1 2.25-2.25h1a2.25 2.25 0 0 1 2.25 2.25v3.05h-5.5V7.78Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const LockFilledIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'lockFilled'),
) as IconWithRender;

LockFilledIcon.displayName = 'LockFilledIcon';
LockFilledIcon.propTypes = Icon.propTypes;
LockFilledIcon.renderIcon = (props) => <LockFilledIcon {...props} />;
export default LockFilledIcon;
